(function () {
  window.dataLayer = window.dataLayer || [];

  function getMeta() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  }

  function cleanText(text) {
    if (!text) return '';
    return String(text).replace(/(\r\n)+|\r+|\n+|\t+/g, '').trim();
  }

  function bindClickEvents(elements, handler, useCapture) {
    if (!elements || !elements.length) return;
    elements.forEach(function (el) {
      el.addEventListener('mousedown', handler, useCapture || false);
      el.addEventListener('touchstart', handler, useCapture || false);
    });
  }

  function linkClick(type, title, url) {
    window.dataLayer.push({
      event: 'linkClick',
      navigation: {
        type: type,
        title: title,
        url: url
      }
    });
  }

  function pageMetaData() {
    var meta = getMeta();
    var page = meta.page || {};
    var langParts = (navigator.language || '').split('-');
    var country = langParts[1] ? langParts[1].toUpperCase() : 'GB';
    var language = langParts[0] ? langParts[0].toUpperCase() : 'EN';

    window.dataLayer.push({
      pageMetaData: {
        page: {
          environment: 'production',
          template: page.pageType || 'unknown',
          title: document.title || 'RoC unknown',
          currency: meta.currency || 'unknown',
          region: 'Europe',
          country: country,
          language: language,
          category1: page.resourceType || 'unknown'
        }
      }
    });
  }

  function bindNavClicks() {
    bindClickEvents(
      document.querySelectorAll('.header__links-primary a, .header__links-secondary a'),
      function () {
        linkClick('headerNav', cleanText(this.innerText) || 'unknown', this.href || 'unknown');
        return false;
      }
    );

    bindClickEvents(
      document.querySelectorAll('.drawer-menu__primary-links a, .drawer-menu__secondary-links a'),
      function () {
        linkClick('mobileNav', cleanText(this.innerText) || 'unknown', this.href || 'unknown');
        return false;
      }
    );

    bindClickEvents(
      document.querySelectorAll('.social-icons a'),
      function () {
        linkClick('socialShare', cleanText(this.innerText) || 'unknown', this.href || 'unknown');
        return false;
      }
    );

    bindClickEvents(
      document.querySelectorAll('.product-item__product-title a'),
      function () {
        linkClick('productLink', cleanText(this.innerText) || 'unknown', this.href || 'unknown');
        return false;
      }
    );
  }

  function productClick(eventName, title, url) {
    var meta = getMeta();
    var product = meta.product || {};
    var variants = product.variants || [];
    var variant = variants[0] || {};

    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currencyCode: meta.currency || 'unknown',
        add: {
          products: [{
            name: variant.name || 'unknown',
            id: product.id || 'unknown',
            price: variant.price || 'unknown',
            category: product.type || 'unknown',
            variant_id: variant.id || 'unknown',
            sku: variant.sku || 'unknown',
            quantity: 1,
            url: url
          }]
        }
      }
    });
  }

  function productDetail() {
    var meta = getMeta();
    var product = meta.product || {};
    var variants = product.variants || [];
    var variant = variants[0] || {};

    window.dataLayer.push({
      event: 'productDetail',
      ecommerce: {
        detail: {
          products: [{
            id: product.id || 'unknown',
            variant_id: variant.id || 'unknown',
            sku: variant.sku || 'unknown',
            name: variant.name || 'unknown',
            price: variant.price || 'unknown',
            category: product.type || 'unknown',
            url: location.href,
            currentcy: meta.currency || 'unknown'
          }]
        }
      }
    });
  }

  function bindVideoIframe(iframe) {
    if (!iframe || iframe.dataset.jfVideoBound === '1') return;
    iframe.dataset.jfVideoBound = '1';

    var parentUrl = iframe.baseURI || 'unknown';
    var videoUrl = iframe.src || 'unknown';

    window.dataLayer.push({
      event: 'videoLoaded',
      video: {
        video_url: videoUrl,
        parent_url: parentUrl
      }
    });

    iframe.addEventListener('mousedown', function () {
      window.dataLayer.push({
        event: 'videoClick',
        video: {
          video_url: videoUrl,
          parent_url: parentUrl
        }
      });
      return false;
    }, false);
  }

  function videoPlay() {
    var videoContainers = document.querySelectorAll('.section-product-video, div.product-video');
    videoContainers.forEach(function (container) {
      container.querySelectorAll('iframe').forEach(bindVideoIframe);
    });

    if (videoContainers.length && window.MutationObserver) {
      videoContainers.forEach(function (container) {
        var observer = new MutationObserver(function () {
          container.querySelectorAll('iframe').forEach(bindVideoIframe);
        });
        observer.observe(container, { childList: true, subtree: true });
      });
    }
  }

  function buyNowClick() {
    bindClickEvents(
      document.querySelectorAll('button.modalOpen'),
      function () {
        productClick('addToCart', cleanText(this.innerText) || 'unknown', location.href || 'unknown');
      },
      true
    );
  }

  function whereToBuy() {
    bindClickEvents(
      document.querySelectorAll('.custom-modal a.modal-btn'),
      function () {
        linkClick('whereToBuyButtonClick', cleanText(this.innerText) || 'unknown', this.href || 'unknown');
        return false;
      }
    );
  }

  function contactFormSubmit() {
    bindClickEvents(
      document.querySelectorAll('[data-section-type="contact-form"] button.contact-form__button[type="submit"]'),
      function () {
        linkClick('ContactFormSubmit', cleanText(this.innerText) || 'unknown', location.href || 'unknown');
        return false;
      }
    );
  }

  function regimenFinder() {
    bindClickEvents(
      document.querySelectorAll('#shopify-section-quiz-dropdown div.select-box-list a.roc-btn'),
      function () {
        linkClick('getResultsButton', cleanText(this.innerText) || 'unknown', location.href || 'unknown');
        return false;
      }
    );
  }

  pageMetaData();
  bindNavClicks();
  videoPlay();
  buyNowClick();
  whereToBuy();

  if (location.href.indexOf('/products/') > -1) {
    productDetail();
  }

  if (document.querySelector('[data-section-type="contact-form"]')) {
    contactFormSubmit();
  }

  if (document.querySelector('.quize-section') || document.querySelector('#shopify-section-quiz-dropdown')) {
    regimenFinder();
  }
})();
